module.exports = __webpack_public_path__ + "img/pr_3.6b963dff.png";